var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2.239 20.03-.66-.234.66.233Zm1.531 1.53.233.66-.233-.66ZM21.268 6.65a.7.7 0 1 0-1.212.7l1.212-.7ZM17.58 4.56a.7.7 0 1 0 .841-1.12l-.84 1.12ZM6.293 20.67l-.233-.66.233.66Zm.865.082.34-.612-.34.612Zm-4.057-4.186-.623.32.623-.32Zm.066.836.66.233-.66-.233ZM2.7 12A9.3 9.3 0 0 1 12 2.7V1.3C6.09 1.3 1.3 6.09 1.3 12h1.4Zm1.024 4.246A9.258 9.258 0 0 1 2.7 12H1.3c0 1.759.425 3.42 1.178 4.886l1.246-.64Zm-.825 4.016.928-2.627-1.32-.466-.928 2.627 1.32.466Zm.638.639a.5.5 0 0 1-.638-.639l-1.32-.466c-.532 1.506.919 2.957 2.424 2.425l-.466-1.32Zm2.523-.892-2.523.892.466 1.32 2.523-.892-.466-1.32ZM12 21.3a9.255 9.255 0 0 1-4.502-1.16l-.68 1.224A10.656 10.656 0 0 0 12 22.7v-1.4Zm9.3-9.3a9.3 9.3 0 0 1-9.3 9.3v1.4c5.91 0 10.7-4.79 10.7-10.7h-1.4Zm-1.244-4.65A9.255 9.255 0 0 1 21.3 12h1.4c0-1.948-.521-3.776-1.432-5.35l-1.212.7ZM12 2.7c2.095 0 4.026.692 5.58 1.86l.841-1.12A10.655 10.655 0 0 0 12 1.3v1.4ZM6.526 21.33a.36.36 0 0 1 .293.034l.679-1.224a1.759 1.759 0 0 0-1.438-.13l.466 1.32Zm-4.048-4.444a.36.36 0 0 1 .03.283l1.32.466c.166-.472.109-.974-.104-1.389l-1.246.64Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.05,
    cy: 12.05,
    r: 1.25,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.05,
    cy: 12.05,
    r: 1.25,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.05,
    cy: 12.05,
    r: 1.25,
    fill: "#fff"
  })));
};
export default SvgMessage;